import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section
      id="contact"
      className="contact"
      style={{
        position: 'relative',
        background: '#ffffff'
      }}
    >
      <div className="section-container">
        <div className="contact-content">
          <div className="contact-panel contact-panel--text">
            <h2 className="section-title">Get in touch</h2>
            <p className="contact-description">
              I'm always open to new connections and helping others. Just send me an email, or find me on any of these platforms! 😊
            </p>
            <div className="contact-links">
              <a
                href="https://www.linkedin.com/in/mina-beiki-58750a1a7/"
                className="contact-pill"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <img className="contact-pill-icon" src="/images/Linkedin_logo.png" alt="LinkedIn" />
              </a>
              <a
                href="https://github.com/mina-beiki"
                className="contact-pill"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <img className="contact-pill-icon" src="/images/github_logo.png" alt="GitHub" />
              </a>
              <a href="mailto:minaabeiki@gmail.com" className="contact-pill" aria-label="Gmail">
                <img className="contact-pill-icon" src="/images/gmail_logo.png" alt="Gmail" />
              </a>
              <a
                href="https://www.instagram.com/minoootik/"
                className="contact-pill"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img className="contact-pill-icon" src="/images/insta_logo.png" alt="Instagram" />
              </a>
            </div>
          </div>
          <div className="contact-panel contact-panel--image">
            <img
              className="contact-card-image"
              src="/images/business_card.jpg"
              alt="Business card"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
